import { Controller } from 'stimulus';
import Rails from '@rails/ujs';

const style = {
  base: {
    color: '#001F3F',
    fontFamily: 'Montserrat, sans-serif',
    fontSmoothing: 'antialiased',
    fontSize: '16px',
    '::placeholder': {
      color: '#C4CCDF',
    },
    lineHeigth: '32px',
  },
  invalid: {
    color: '#DF2C2C',
    iconColor: '#DF2C2C',
  },
};

const classes = {
  base: 'border border-gray-400 w-full pl-4 h-10 py-2 focus:outline-none',
};

const cardPlaceholder = '0000 1111 2222 3333';

export default class extends Controller {
  static targets = ['number', 'expiry', 'cvc', 'errors', 'paymentMethodId', 'submitButton'];

  connect() {
    this.stripe = window.Stripe(this.apiKey);
    this.elements = this.stripe.elements();

    this.cardNumber = this.elements.create('cardNumber', { classes, style, placeholder: cardPlaceholder });
    this.cardNumber.mount(this.numberTarget);

    this.cardExpiry = this.elements.create('cardExpiry', { classes, style, placeholder: this.expiryPlaceholder });
    this.cardExpiry.mount(this.expiryTarget);

    this.cardCvc = this.elements.create('cardCvc', { classes, style });
    this.cardCvc.mount(this.cvcTarget);
  }

  disconnect() {
    this.cardNumber.unmount(this.numberTarget);
    this.cardExpiry.unmount(this.expiryTarget);
    this.cardCvc.unmount(this.cvcTarget);
    this.elements = null;
    this.stripe = null;
  }

  async submit(event) {
    event.preventDefault();

    const { paymentMethod, error } = await this.stripe.createPaymentMethod({
      type: 'card',
      card: this.cardNumber,
    });

    if (error) {
      const { message } = error;
      this.errorsTarget.textContent = message;
      window.setTimeout(() => {
        Rails.enableElement(this.submitButtonTarget);
      }, 100);
    } else {
      this.paymentMethodIdTarget.value = paymentMethod.id;
      this.element.submit();
    }
  }

  get expiryPlaceholder() {
    return this.data.get('expiry-placeholder');
  }

  get apiKey() {
    return this.data.get('api-key');
  }
}
